module.exports = __webpack_public_path__ + "static/media/tempered_sm.08e41131.jpg";